import { Avatar, AvatarGroup } from '@chatscope/chat-ui-kit-react';
import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { RootState, AppDispatch } from 'store';
import userDummyImg from "../../assets/images/users/user-dummy-img.jpg"
import { CompetitionGroup } from 'types/competition-analysis';
import { fetchCompetitionAnalysisGroupsThunk } from 'slices/competitionAnalysis/thunk';
import { report } from 'process';

const Reports: React.FC<{ onEdit?: (report: CompetitionGroup) => void }> = ({ onEdit }) => {
    const groupsData = useSelector((state: RootState) => state.competitionAnalysis.groups);
    const loading = groupsData?.loading;
    const error = groupsData?.error;
    const groups = groupsData.items ?? [];
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const [initialLoading, setInitialLoading] = useState(false);

    useEffect(() => {
        setInitialLoading(true);
        dispatch(fetchCompetitionAnalysisGroupsThunk({ force: false })).finally(() => setInitialLoading(false));
    }, [])

    return (
        <div className="card campaign-insights-card mt-4">
            <div className="card-body p-0 m-0">

                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className='text-start ps-4'>Competitors</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !initialLoading && groups.map((group, i) => {
                                return (
                                    <tr className="border-bottom-1 px-3" key={i}>
                                        <td>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-start align-items-center gap-3 border-right-dashed td-content">
                                                    <div className="d-flex flex-column justify-content-center">
                                                        <div className="d-flex align-items-center gap-1">
                                                            {
                                                                group.accounts.filter(acc => acc.status === "active").length > 0 ? <Link to={{ pathname: `/competitor/${group.uuid}` }} className='linked-posts-ig-username'>{group.name}</Link> : <span className='linked-posts-ig-username text-muted'>{group.name}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='ps-4'>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-start align-items-center gap-1 border-right-dashed td-content">
                                                    <span className="d-flex align-items-center">
                                                        <AvatarGroup>
                                                            {group.accounts.map((acc) => (
                                                                <React.Fragment key={acc.social_account.uuid}>
                                                                    <Avatar
                                                                        id={`avatar-${acc.social_account.uuid}`}
                                                                        src={acc.social_account.profile_picture_url ?? userDummyImg}
                                                                        name={acc.social_account.name}
                                                                        style={{ filter: acc.status === "inactive" ? "grayscale(100%) opacity(1)" : "none" }}
                                                                    />

                                                                    <UncontrolledTooltip
                                                                        innerClassName="custom-tooltip"
                                                                        placement="top"
                                                                        target={`avatar-${acc.social_account.uuid}`}
                                                                    >
                                                                        <b>{acc.social_account.name}</b>
                                                                    </UncontrolledTooltip>
                                                                </React.Fragment>
                                                            ))}
                                                        </AvatarGroup>
                                                        <button onClick={() => onEdit?.(group)} id={`add-competitor-${group.uuid}`} className='btn-link unset-all text-primary add-competitor-btn'><i className='bx bx-plus fs-3'></i></button>
                                                        <UncontrolledTooltip
                                                            innerClassName="custom-tooltip"
                                                            placement="top"
                                                            target={`add-competitor-${group.uuid}`}
                                                        >
                                                            Add Competitor
                                                        </UncontrolledTooltip>
                                                    </span>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='ps-4'>
                                            <div className="py-3">
                                                <div className="d-flex justify-content-end pe-5 align-items-center gap-3 td-content">
                                                    {
                                                        (group.accounts.filter(acc => acc.status === "active").length > 0) &&
                                                        <>
                                                            <Link to={{ pathname: `/competitor/${group.uuid}` }} id={`view-competitor-${group.uuid}`} className='btn-link unset-all text-primary cursor-pointer'><i className='mdi mdi-eye mb-2 fs-4  me-1'></i></Link>
                                                            <UncontrolledTooltip
                                                                innerClassName="custom-tooltip"
                                                                placement="top"
                                                                target={`view-competitor-${group.uuid}`}
                                                            >
                                                                View Report
                                                            </UncontrolledTooltip>
                                                        </>
                                                    }
                                                    <button id={`edit-competitor-${group.uuid}`} onClick={() => onEdit?.(group)} className='btn-link unset-all text-primary'><i className='bx bxs-edit fs-4 mt-1'></i></button>
                                                    <UncontrolledTooltip
                                                        innerClassName="custom-tooltip"
                                                        placement="top"
                                                        target={`edit-competitor-${group.uuid}`}
                                                    >
                                                        Edit Report
                                                    </UncontrolledTooltip>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        {
                            !initialLoading && !loading &&
                            <td colSpan={4}>
                                <div>
                                    Showing {groups.length} of {groupsData.count} Records
                                </div>
                            </td>
                        }
                        {
                            (loading || initialLoading) &&
                            Array.from({ length: 10 }).map((_, i) => {
                                return (
                                    <tr>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                        <td><Skeleton /></td>
                                        {/* <td><Skeleton /></td>
                                                <td><Skeleton /></td>
                                                <td><Skeleton /></td> */}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                {
                    !(loading || initialLoading) && groups.length === 0 &&
                    <div className="d-flex w-100 justify-content-center align-items-center my-5">
                        <div className="length-zero my-5 d-flex flex-column gap-2">
                            <h3>No reports created yet</h3>
                            <span>Create your first competition report to start tracking competitor performance and insights.</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default Reports
